import { lazy } from 'react';

// 订单管理
const OrderList = lazy(() => import('pages/orderList'));
// 订单详情
const OrderDetail = lazy(() => import('pages/orderDetail'));

const router = {
    path: '/order',
    name: '订单管理',
    icon: 'file-text',
    permission: 104,
    children: [
        {
            path: 'list',
            name: '订单列表',
            icon: 'file-text',
            permission: 10401,
            component: OrderList,
        },
        {
            path: 'detail',
            name: '订单详情',
            icon: '_space',
            permission: 10401,
            hideInMenu: true,
            component: OrderDetail,
        },
    ],
};

export default router;
